import { css as h, LitElement as m, nothing as c, html as g } from "lit";
import { property as o, customElement as d } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b as v } from "./styles-scZ6dVz-.js";
var x = Object.defineProperty, y = Object.getOwnPropertyDescriptor, s = (r, a, n, i) => {
  for (var t = i > 1 ? void 0 : i ? y(a, n) : a, l = r.length - 1, p; l >= 0; l--)
    (p = r[l]) && (t = (i ? p(a, n, t) : p(t)) || t);
  return i && t && x(a, n, t), t;
};
let e = class extends m {
  constructor() {
    super(...arguments), this.value = 0, this.max = 100, this.variant = "default", this.size = "md", this.indeterminate = !1, this.showValue = !1;
  }
  get percentage() {
    const r = Math.max(0, Math.min(this.value, this.max));
    return Math.round(r / this.max * 100);
  }
  get sizeValue() {
    switch (this.size) {
      case "xs":
        return 32;
      case "sm":
        return 48;
      case "md":
        return 64;
      case "lg":
        return 80;
      case "xl":
        return 96;
      default:
        return 64;
    }
  }
  get strokeWidth() {
    switch (this.size) {
      case "xs":
        return 3;
      case "sm":
        return 4;
      case "md":
        return 5;
      case "lg":
        return 6;
      case "xl":
        return 7;
      default:
        return 5;
    }
  }
  render() {
    const r = this.sizeValue, a = this.strokeWidth, n = (r - a) / 2, i = 2 * Math.PI * n, t = this.indeterminate ? 0 : i - this.percentage / 100 * i, l = {
      container: !0,
      [this.variant]: !0,
      [this.size]: !0,
      indeterminate: this.indeterminate
    }, p = this.showValue || this.label || this.displayValue, u = this.displayValue ?? `${this.percentage}%`;
    return g`
      <div
        class=${f(l)}
        role="progressbar"
        aria-valuenow=${this.indeterminate ? c : this.value}
        aria-valuemin="0"
        aria-valuemax=${this.max}
        aria-label=${this.label || "Progress"}
      >
        <svg
          part="svg"
          width=${r}
          height=${r}
          viewBox="0 0 ${r} ${r}"
        >
          <circle
            part="track"
            class="track"
            cx=${r / 2}
            cy=${r / 2}
            r=${n}
            stroke-width=${a}
          />
          <circle
            part="progress"
            class="progress"
            cx=${r / 2}
            cy=${r / 2}
            r=${n}
            stroke-width=${a}
            stroke-dasharray=${i}
            stroke-dashoffset=${t}
          />
        </svg>
        ${p ? g`
              <div part="content" class="content">
                <slot>
                  ${this.showValue && !this.indeterminate ? g`<span class="value">${u}</span>` : c}
                  ${this.label ? g`<span class="label">${this.label}</span>` : c}
                </slot>
              </div>
            ` : c}
      </div>
    `;
  }
};
e.styles = [
  v,
  h`
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .container {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      svg {
        transform: rotate(-90deg);
        overflow: visible;
      }

      .track {
        fill: none;
        stroke: var(--ark-progress-ring-track-color, var(--r5-bg-muted));
      }

      .progress {
        fill: none;
        stroke: var(--ark-progress-ring-progress-color, var(--r5-color-primary-600));
        stroke-linecap: round;
        transition: stroke-dashoffset var(--r5-duration-normal) var(--r5-ease-out);
      }

      /* Size variants */
      .xs {
        --ring-size: 32px;
        --stroke-width: 3px;
        --font-size: var(--r5-text-2xs);
      }

      .sm {
        --ring-size: 48px;
        --stroke-width: 4px;
        --font-size: var(--r5-text-xs);
      }

      .md {
        --ring-size: 64px;
        --stroke-width: 5px;
        --font-size: var(--r5-text-sm);
      }

      .lg {
        --ring-size: 80px;
        --stroke-width: 6px;
        --font-size: var(--r5-text-base);
      }

      .xl {
        --ring-size: 96px;
        --stroke-width: 7px;
        --font-size: var(--r5-text-lg);
      }

      /* Color variants */
      .default .progress {
        --ark-progress-ring-progress-color: var(--r5-color-primary-600);
      }

      .success .progress {
        --ark-progress-ring-progress-color: var(--r5-color-success-600);
      }

      .warning .progress {
        --ark-progress-ring-progress-color: var(--r5-color-warning-600);
      }

      .danger .progress {
        --ark-progress-ring-progress-color: var(--r5-color-danger-600);
      }

      .info .progress {
        --ark-progress-ring-progress-color: var(--r5-color-info-600);
      }

      .content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: var(--font-size, var(--r5-text-sm));
      }

      .value {
        font-weight: var(--r5-font-bold);
        color: var(--r5-text);
        line-height: 1.2;
      }

      .label {
        font-size: 0.7em;
        color: var(--r5-text-muted);
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-top: 2px;
      }

      /* Indeterminate animation */
      .indeterminate .progress {
        animation: ark-progress-ring-spin 1.5s linear infinite;
        stroke-dasharray: 50% 150%;
      }

      @keyframes ark-progress-ring-spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `
];
s([
  o({ type: Number })
], e.prototype, "value", 2);
s([
  o({ type: Number })
], e.prototype, "max", 2);
s([
  o({ type: String, reflect: !0 })
], e.prototype, "variant", 2);
s([
  o({ type: String, reflect: !0 })
], e.prototype, "size", 2);
s([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "indeterminate", 2);
s([
  o({ type: Boolean, attribute: "show-value" })
], e.prototype, "showValue", 2);
s([
  o({ type: String })
], e.prototype, "label", 2);
s([
  o({ type: String, attribute: "display-value" })
], e.prototype, "displayValue", 2);
e = s([
  d("ark-progress-ring")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-progress-ring-B0enagDt.js.map
